






// vue
import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({
  name: 'App'
})
export default class App extends Vue {
  chageTitlePage () {
    const nameApp = this.$store.getters.nameApp
    const titlePage = this.$store.getters.titlePage
    const titleCompleted = titlePage + (nameApp ? ' | ' + nameApp : '')
    document.title = titleCompleted
  }

  @Watch('$route', { immediate: true, deep: true })
  changeRoute () {
    if (this.$route?.meta?.title) {
      this.$store.commit('setTitle', this.$route.meta.title)
    }
    this.chageTitlePage()
  }
}
